<template>
  <form id="causeOfMaintanceForm" class="mx-auto col-sm-8" @submit.prevent>
    <div
      class="form-group"
      :class="{ 'has-error': errors.has('cause_of_maintance') }"
    >
      <label for="cause_of_maintance">{{ $t("cause_of_maintance") }}</label>
      <input
        type="text"
        id="cause_of_maintance"
        name="cause_of_maintance"
        class="form-control"
        :placeholder="$t('ph_cause_of_maintance')"
        v-model="causeOfMaintance.name"
        v-validate="'required'"
      />
      <small v-show="errors.has('cause_of_maintance')" class="form-text">
        {{ errors.first("cause_of_maintance") }}
      </small>
    </div>

    <div class="switch mb-3">
      <label for="isActive">{{ $t("active") }}</label>
      <div class="onoffswitch2">
        <input
          type="checkbox"
          class="onoffswitch2-checkbox"
          id="isActive"
          v-model="causeOfMaintance.isActive"
        />
        <label class="onoffswitch2-label" for="isActive">
          <span class="onoffswitch2-inner"></span>
          <span class="onoffswitch2-switch"></span>
        </label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton
          @click="onClick"
          :loading="isLoading"
        >
          {{ $t("save") }}
        </LoaderButton>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoaderButton from "@/components/button/LoaderButton";

export default {
  name: "CauseOfMaintanceForm",

  components: {
    LoaderButton,
  },

  props: {
    causeOfMaintance: {
      type: Object,
      default: () => ({
        name: "",
        isActive: true,
      }),
    },
  },

  computed: {
    ...mapState({
      isLoading: state => state.causeofmaintance.isLoading
    })
  },

  methods: {
    ...mapActions("causeofmaintance", ["create", "edit", "cleanState"]),

    async onClick(evtClick, doneFn) {
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        const err = new Error(this.$t("invalid_form_fields"));

        this.$store.dispatch("notify/error", err);

        return;
      }

      const { id } = this.causeOfMaintance;

      const result = id
        ? await this.edit({ id, data: this.causeOfMaintance })
        : await this.create(this.causeOfMaintance);

      if (result) {
        this.$router.push({ name: "listcauseofmaintance" });
      }
    },
  },
  destroyed() {
    this.cleanState();
  },
};
</script>
